import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ATasteOfItaly() {
  const [cookieAccepted, setCookieAccepted] = useState(false);
  return <section data-section-id="223782" id="echi-di-pace-tra-le-vette" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/image_0x5me15l.jpg)]" />

      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

      {}
      <div className="relative z-10 flex flex-col items-center px-4 text-center max-w-2xl">
        <span className="font-sans uppercase tracking-[0.3em] animate-pulse text-destructive !font-extrabold ![margin:0px_0px_18px_0px] !h-[30px] !text-2xl">ECHI nel SILENZIO</span>
        <h1 className="mb-10 font-default text-5xl text-foreground tracking-tight md:text-[84px] md:leading-[1.1] drop-shadow-[0_0_15px_rgba(180,120,60,0.3)]">Vibrare e Pregare</h1>

        {!cookieAccepted && <div className="flex flex-col items-center gap-8">
            <p className="text-center text-sm font-serif text-secondary leading-relaxed max-w-md">
              Utilizziamo i cookie, anche di terze parti, per migliorare l'esperienza di navigazione e raccogliere informazioni circa l'utilizzo del sito. Clicca qui per saperne di più sulla nostra <Link to="#" className="underline hover:text-primary transition-colors">Cookie Policy</Link>.
            </p>

            <div className="flex flex-wrap justify-center gap-4">
              <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 uppercase tracking-widest px-6 py-4 text-xs" onClick={() => setCookieAccepted(true)}>
                Gestisci preferenze
              </Button>
              <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 uppercase tracking-widest px-6 py-4 text-xs" onClick={() => setCookieAccepted(true)}>
                Accetta solo essenziali
              </Button>
              <Button variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 uppercase tracking-widest px-8 py-4 text-xs font-bold" onClick={() => setCookieAccepted(true)}>
                Accetta tutti
              </Button>
            </div>
          </div>}
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 z-10 -translate-x-1/2 animate-bounce">
        <ChevronDown className="size-10 text-primary/60" strokeWidth={1} />
      </div>
    </section>;
}